export type WeaveSensitiveDataPolicy = 'off' | 'pii-v1';

export const parseWeaveSensitiveDataPolicy = (
  policy: unknown
): WeaveSensitiveDataPolicy | null => {
  // Unset must read as 'off' to match ProjectPermissionsResolver.EffectiveSensitiveDataPolicy.
  if (policy == null || policy === '') {
    return 'off';
  }
  if (policy === 'off' || policy === 'pii-v1') {
    return policy;
  }
  return null;
};
